import { useQuery } from "@tanstack/react-query";
import { ShieldAlert } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { ordenesCompraService } from "@/services/ordenes-compra.service";

const TONO: Record<string, string> = {
  alto: "border-destructive/40 bg-destructive/5 text-destructive",
  medio: "border-warning/40 bg-warning/5 text-warning",
  bajo: "border-success/40 bg-success/5 text-success",
};

/**
 * Señal "Riesgo de proveedor favorito": concentración del gasto real del
 * organismo en un solo proveedor, calculada sobre órdenes de compra.
 */
export function RiesgoFavoritoCard({ organismo, meses = 24 }: { organismo: string; meses?: number }) {
  const q = useQuery({
    queryKey: ["oc-analytics", "riesgo-favorito", organismo, meses],
    queryFn: () => ordenesCompraService.riesgoFavorito(organismo, meses),
    enabled: !!organismo,
  });

  if (q.isLoading) return <Skeleton className="h-24 w-full rounded-xl" />;
  if (q.error || !q.data) return null;

  const d = q.data;
  return (
    <div className={`rounded-xl border p-4 ${TONO[d.nivel] ?? "border-border bg-card"}`}>
      <div className="flex items-center gap-2 mb-1.5">
        <ShieldAlert className="size-4" />
        <span className="font-display font-semibold text-sm">
          Riesgo de proveedor favorito · {d.nivel}
        </span>
      </div>
      <p className="text-sm text-foreground/90">{d.detalle}</p>
      <div className="mt-2 grid grid-cols-3 gap-2 text-[11px] text-muted-foreground">
        <span>{d.ordenes} órdenes analizadas</span>
        <span>{d.proveedores} proveedores distintos</span>
        <span>{d.canalPredominante ?? "Canal mixto"}</span>
      </div>
      {d.penalizacion > 0 && (
        <p className="mt-2 text-[11px] text-muted-foreground">
          El motor descuenta {d.penalizacion} puntos del score por esta señal.
        </p>
      )}
    </div>
  );
}
